import { Button, Card, CardContent, CardHeader, Grid, Typography, Chip, Box, Divider } from "@mui/material";
import { useState } from "react";
import { apiConstants, getGeneric, postGeneric } from '../../common/constants'
import * as React from 'react'
import PageTitle from "../../components/PageTitle";
import { useSnackbar } from "notistack";
import Loader from "../../common/Loader";
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { FormProvider, RHFSelectField } from "../../common/hook-form";
import { LoadingButton } from "@mui/lab";
import { MerchantFilterCached } from "../../common/ProshipFormComponents";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';

function AutomatedNdrConfig() {
    const [configData, setConfigData] = useState(false);
    const [loading, setLoading] = useState(false)
    const { enqueueSnackbar } = useSnackbar();
    const [isData, setIsData] = useState(false);

    const methods = useForm({
        defaultValues: {
            merchant: '',
            status: '',
        },
        resolver: yupResolver(Yup.object().shape({
            status: Yup.mixed().required('Please select a status'),
        }))
    });

    const {
        handleSubmit,
        reset,
        getValues,
        setValue
    } = methods;

    const onSubmit = (data) => {
        postGeneric(`${apiConstants.MERCHANT_DETAILS}/${data.merchant}/automatedNDR?flag=${data.status}`).then((res) => {
            if (res?.status === 200) {
                enqueueSnackbar("Success", { variant: 'success' });
                merchantFilter()
            } else {
                enqueueSnackbar(res.data?.errorMsg || "Some error occurred", { variant: 'error' });
            }
        }).catch((err) => {
            enqueueSnackbar("Some error occurred", { variant: 'error' });
            console.log(err);
        })
    };

    const merchantFilter = () => {
        const id = getValues().merchant
        if (id) {
            setLoading(true)
            getGeneric(`${apiConstants.MERCHANT_DETAILS}/${id}`).then((res) => {
                setIsData(true)
                const current = res.data?.whatsappAutomatedNdr
                setConfigData(current)
                // Pre-select the current value in the editable dropdown too.
                setValue('status', current === undefined || current === null ? '' : Boolean(current))
                setLoading(false)
            }).catch((err) => {
                setLoading(false)
                console.log(err);
            })
        }
    }

    return (
        <div>
            {loading && <Loader />}
            <PageTitle>Automated NDR via Whatsapp</PageTitle>
            <Grid sx={{ paddingBottom: 2 }}>
                <Card>
                    <CardHeader
                        title="WhatsApp NDR Automation"
                        subheader="Enable or disable automated NDR notifications via WhatsApp for a merchant"
                        titleTypographyProps={{ variant: 'h6', fontWeight: 600 }}
                        subheaderTypographyProps={{ variant: 'body2' }}
                    />
                    <Divider />
                    <CardContent>
                        <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
                            <Grid container spacing={2} alignItems="center">
                                <Grid item xs={12} md={4}>
                                    <MerchantFilterCached name="merchant" label="Select Merchant" />
                                </Grid>
                                <Grid item xs={12} md={8}>
                                    <LoadingButton
                                        variant="contained"
                                        size="small"
                                        onClick={() => merchantFilter()}
                                    >
                                        Search
                                    </LoadingButton>
                                    <Button
                                        sx={{ ml: 1 }}
                                        variant="outlined"
                                        color="error"
                                        size="small"
                                        onClick={() => { reset(); setConfigData(false); setIsData(false) }}
                                    >
                                        Reset
                                    </Button>
                                </Grid>
                            </Grid>

                            {!isData && (
                                <Typography variant="caption" color="text.secondary" sx={{ mt: 2, display: 'block' }}>
                                    Please select a merchant to view details
                                </Typography>
                            )}

                            {isData && (
                                <>
                                    <Divider sx={{ my: 2 }} />

                                    {/* Current Status Display */}
                                    <Box sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 1.5,
                                        p: 2,
                                        mb: 2,
                                        borderRadius: 1,
                                        bgcolor: configData ? 'success.lighter' : 'grey.100',
                                        border: '1px solid',
                                        borderColor: configData ? 'success.light' : 'grey.300',
                                    }}>
                                        {configData
                                            ? <CheckCircleIcon sx={{ color: 'success.main', fontSize: 22 }} />
                                            : <CancelIcon sx={{ color: 'text.disabled', fontSize: 22 }} />
                                        }
                                        <Typography variant="subtitle2">
                                            Current Status:
                                        </Typography>
                                        <Chip
                                            label={configData ? 'Active' : 'Inactive'}
                                            color={configData ? 'success' : 'error'}
                                            size="small"
                                            variant="filled"
                                        />
                                    </Box>

                                    {/* Update Form */}
                                    <Typography variant="subtitle2" sx={{ mb: 1 }}>Update Status</Typography>
                                    <Grid container spacing={2} alignItems="center">
                                        <Grid item xs={12} md={4}>
                                            <RHFSelectField width="100%" name="status" label="WhatsApp NDR"
                                                options={[
                                                    { value: true, label: 'Enable' },
                                                    { value: false, label: 'Disable' }
                                                ]}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <LoadingButton type="submit" size="small" variant="contained">
                                                Update
                                            </LoadingButton>
                                        </Grid>
                                    </Grid>
                                </>
                            )}
                        </FormProvider>
                    </CardContent>
                </Card>
            </Grid>
        </div>
    );
}
export default AutomatedNdrConfig;
